export class UserImportRecord {
    FirstName: string
    LastName: string
    Email: string
    Role: string
    PhoneNumber: string
    SeatType: string
    SecondaryPhoneNumbers: string
    PhoneNumberGroups: string
    Errors: Record<string, string>
}

export class UserImportReportSummary {
    Id: string
    FileName: string
    Status: string
    CreatedDateTime: string
    CreatedBy: string
    SavedCount: number
    IgnoredCount: number
    TotalCount: number
    Source: string
}

export class UserImportReport {
    Id: string
    IsDeleted: boolean
    CreatedDateTime: string
    CreatedById: string
    CreatedBy: string
    FileName: string
    SavedRecords: UserImportRecord[]
    IgnoredRecords: UserImportRecord[]
    Status: string
}

const asText = (value: any) => value == null ? "" : String(value)

const countOf = (records: any, count: any) => {
    if (typeof count === "number") return count
    if (Array.isArray(records)) return records.length
    if (typeof records === "number") return records
    return 0
}

const mapRecord = (record: any): UserImportRecord => ({
    FirstName: asText(record?.firstName ?? record?.FirstName),
    LastName: asText(record?.lastName ?? record?.LastName),
    Email: asText(record?.email ?? record?.Email),
    Role: asText(record?.role ?? record?.Role),
    PhoneNumber: asText(record?.phoneNumber ?? record?.PhoneNumber),
    SeatType: asText(record?.seatType ?? record?.SeatType),
    SecondaryPhoneNumbers: asText(record?.secondaryPhoneNumbers ?? record?.SecondaryPhoneNumbers),
    PhoneNumberGroups: asText(record?.phoneNumberGroups ?? record?.PhoneNumberGroups),
    Errors: record?.errors || record?.Errors || {}
})

const mapRecords = (records: any): UserImportRecord[] => {
    return Array.isArray(records) ? records.map(mapRecord) : []
}

export const mapToUserImportReportSummary = (report: any): UserImportReportSummary => ({
    Id: asText(report?.id ?? report?.Id),
    FileName: asText(report?.fileName ?? report?.FileName),
    Status: asText(report?.status ?? report?.Status),
    CreatedDateTime: asText(report?.createdDateTime ?? report?.CreatedDateTime),
    CreatedBy: asText(report?.createdBy ?? report?.CreatedBy),
    SavedCount: countOf(report?.savedRecords ?? report?.SavedRecords, report?.savedCount ?? report?.SavedCount),
    IgnoredCount: countOf(report?.ignoredRecords ?? report?.IgnoredRecords, report?.ignoredCount ?? report?.IgnoredCount),
    TotalCount: countOf(report?.totalRecords ?? report?.TotalRecords, report?.totalCount ?? report?.TotalCount),
    Source: asText(report?.source ?? report?.Source)
})

export const mapToUserImportReport = (report: any): UserImportReport => ({
    Id: asText(report?.id ?? report?.Id),
    IsDeleted: !!(report?.isDeleted ?? report?.IsDeleted),
    CreatedDateTime: asText(report?.createdDateTime ?? report?.CreatedDateTime),
    CreatedById: asText(report?.createdById ?? report?.CreatedById),
    CreatedBy: asText(report?.createdBy ?? report?.CreatedBy),
    FileName: asText(report?.fileName ?? report?.FileName),
    SavedRecords: mapRecords(report?.savedRecords ?? report?.SavedRecords),
    IgnoredRecords: mapRecords(report?.ignoredRecords ?? report?.IgnoredRecords),
    Status: asText(report?.status ?? report?.Status)
})
